export default __webpack_public_path__ + "images/DVR.7908041.png";